<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div class="campaign-table">
    <campaign-add-edit-dialog
      ref="campaignAddEditDialog"
      @actionSuccess="$emit('campaignUpdated')"
    ></campaign-add-edit-dialog>
    <twitter-campaign-analytics-dialog ref="twitterCampaignAnalyticsDialog"></twitter-campaign-analytics-dialog>
    <instagram-campaign-analytics-dialog ref="instagramCampaignAnalyticsDialog"></instagram-campaign-analytics-dialog>
    <instagram-instantwin-campaign-analytics-dialog
      ref="instagramInstantwinCampaignAnalyticsDialog"
    ></instagram-instantwin-campaign-analytics-dialog>
    <tiktok-campaign-analytics-dialog ref="tiktokCampaignAnalyticsDialog"></tiktok-campaign-analytics-dialog>
    <el-table class="mb-x2" :data="campaigns" stripe @header-click="headerClick" empty-text=" " style="width: 100%">
      <el-table-column label="ステータス" sort-by="-status" :render-header="renderHeader" min-width="12%">
        <template slot-scope="scope">
          <campaign-status
            :status="scope.row.status"
            :entry-action-type="scope.row.entryActionType"
            :applicants-count="scope.row.applicantsCount"
          ></campaign-status>
        </template>
      </el-table-column>
      <el-table-column label="タイトル" sort-by="title" :render-header="renderHeader" min-width="22%">
        <template slot-scope="scope">
          <div
            class="link"
            layout="row"
            layout-align="start-center"
            v-if="scope.row.type === 'instantwin'"
            @click="clickCampaignTitleEvent(scope.row.targetSns, scope.row.type, scope.row.id)"
          >
            <el-tooltip :enterable="false" placement="top" :content="scope.row.account.name">
              <icon
                class="mr-x1"
                :name="scope.row.account.name"
                :picture-url="scope.row.account.pictureUrl"
                :icon-type="scope.row.targetSns"
              ></icon>
            </el-tooltip>
            <div>
              <div class="campaign-title">{{ scope.row.title }}</div>
              <div class="badge badge-danger mt-x1">インスタントウィン</div>
            </div>
          </div>
          <div v-else>
            <div
              class="link"
              v-if="scope.row.targetSns === 'twitter'"
              layout="row"
              layout-align="start-center"
              @click="clickCampaignTitleEvent(scope.row.targetSns, scope.row.type, scope.row.id)"
            >
              <el-tooltip :enterable="false" placement="top" :content="scope.row.account.name">
                <icon
                  class="mr-x1"
                  :name="scope.row.account.name"
                  :picture-url="scope.row.account.pictureUrl"
                  icon-type="twitter"
                ></icon>
              </el-tooltip>
              <div>
                <div class="campaign-title">{{ scope.row.title }}</div>
                <div class="badge badge-danger mt-x1" v-if="scope.row.type === 'old_web_instantwin'">
                  WEBインスタントウィン
                </div>
              </div>
            </div>
            <div
              class="link"
              v-else-if="scope.row.targetSns === 'instagram'"
              layout="row"
              layout-align="start-center"
              @click="clickCampaignTitleEvent(scope.row.targetSns, scope.row.type, scope.row.id)"
            >
              <el-tooltip :enterable="false" placement="top" :content="scope.row.account.name">
                <icon
                  class="mr-x1"
                  :name="scope.row.account.name"
                  :picture-url="scope.row.account.pictureUrl"
                  icon-type="instagram"
                ></icon>
              </el-tooltip>
              <div class="campaign-title">{{ scope.row.title }}</div>
            </div>
            <div
              class="link"
              v-else-if="scope.row.targetSns === 'tiktok'"
              layout="row"
              layout-align="start-center"
              @click="clickCampaignTitleEvent(scope.row.targetSns, scope.row.type, scope.row.id)"
            >
              <el-tooltip placement="top" :content="scope.row.account.name">
                <icon
                  class="mr-x1"
                  :name="scope.row.account.name"
                  :picture-url="scope.row.account.pictureUrl"
                  icon-type="tiktok"
                ></icon>
              </el-tooltip>
              <div class="campaign-title">{{ scope.row.title }}</div>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="応募条件" :render-header="renderHeader" min-width="14%">
        <template slot-scope="scope">
          <div class="entry-action-cell">
            {{ getEntryActionListLabel(scope.row.targetSns, scope.row.type, scope.row.entryActionType) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="期間" sort-by="-startDatetime" :render-header="renderHeader" min-width="19%">
        <template slot-scope="scope">
          <div class="period-cell">{{ formatDatetime(scope.row.startDatetime) }} -</div>
          <div class="period-cell">{{ formatDatetime(scope.row.endDatetime) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="応募者数" :render-header="renderHeader" min-width="8%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.applicantsCount) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="当選者数" :render-header="renderHeader" min-width="8%">
        <template slot-scope="scope">
          <div>{{ formatNumber(scope.row.winnerCount) }}</div>
          <div class="sub-value">残り:&nbsp;{{ formatNumber(scope.row.winnerRemain) }}</div>
        </template>
      </el-table-column>
      <el-table-column label="フォロワー増減数" :render-header="renderHeader" min-width="9%">
        <template slot-scope="scope">
          <div class="text-success" v-if="scope.row.followerUpDown > 0">
            +{{ formatNumber(scope.row.followerUpDown) }}
          </div>
          <div class="text-danger" v-else-if="scope.row.followerUpDown < 0">
            {{ formatNumber(scope.row.followerUpDown) }}
          </div>
          <div v-else>{{ formatNumber(scope.row.followerUpDown) }}</div>
        </template>
      </el-table-column>
      <el-table-column min-width="25%">
        <template slot-scope="scope">
          <div layout layout-align="end">
            <!-- 編集-->
            <el-tooltip :enterable="false" placement="top" content="編集">
              <el-button
                class="el-button--icon"
                type="default"
                @click="openEditDialog(scope.row.targetSns, scope.row.id, scope.row.type)"
                :disabled="contractStatus === 3"
                ><i class="mdi mdi-table-edit"></i
              ></el-button>
            </el-tooltip>
            <!-- 応募収集URL設定（通常キャンペーンのリポスト/引用系のみ）-->
            <IconButtonWithBadge
              name="link-variant"
              v-if="shouldShowUrlSettingIcon(scope.row)"
              tooltip="応募収集URL"
              :disabled="contractStatus === 3"
              :show-badge="scope.row.hasTweetPostUrl"
              badge-variant="active"
              @click="openTweetPostDialog(scope.row)"
            >
              <template #badge><MdiIcon name="check" /></template>
            </IconButtonWithBadge>
            <!-- Xで確認--><a
              class="ml-x1"
              v-if="scope.row.targetSns === 'twitter'"
              :href="'https://x.com/' + scope.row.account.screenName"
              target="_blank"
              @click="clickSnsConfirmEvent(scope.row.targetSns, scope.row.type)"
            >
              <el-tooltip :enterable="false" placement="top" :content="'Xで確認'">
                <el-button class="el-button--icon" type="default"
                  ><i class="mdi mdi-open-in-new"></i
                ></el-button> </el-tooltip
            ></a>
            <!-- Instagramで確認--><a
              class="ml-x1"
              v-if="scope.row.targetSns === 'instagram'"
              :href="'https://instagram.com/' + scope.row.account.screenName"
              target="_blank"
              @click="clickSnsConfirmEvent(scope.row.targetSns, scope.row.type)"
            >
              <el-tooltip :enterable="false" placement="top" :content="'Instagramで確認'">
                <el-button class="el-button--icon" type="default"
                  ><i class="mdi mdi-open-in-new"></i
                ></el-button> </el-tooltip
            ></a>
            <!-- TikTokで確認--><a
              class="ml-x1"
              v-if="scope.row.targetSns === 'tiktok'"
              :href="'https://www.tiktok.com/@' + scope.row.account.screenName"
              target="_blank"
              @click="clickSnsConfirmEvent(scope.row.targetSns, scope.row.type)"
            >
              <el-tooltip :enterable="false" placement="top" :content="'TikTokで確認'">
                <el-button class="el-button--icon" type="default"
                  ><i class="mdi mdi-open-in-new"></i
                ></el-button> </el-tooltip
            ></a>
            <!-- Web応募ページ（Xウェブインスタントウィンのみ）-->
            <el-dropdown
              class="ml-x1"
              v-if="scope.row.targetSns === 'twitter' && scope.row.type === 'old_web_instantwin'"
              trigger="click"
              placement="bottom-start"
              @command="selectActionMenu"
            >
              <el-tooltip :enterable="false" placement="top" content="キャンペーン応募ページ">
                <el-button class="el-button--icon" type="default"
                  ><img src="@/client/assets/images/twitter-web-instant-circle.svg"
                /></el-button>
              </el-tooltip>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="applicant_page_sample_dialog"
                  ><a
                    class="ml-x1"
                    :href="scope.row.webInstantwinPageUrl"
                    target="_blank"
                    @click="clickSnsConfirmEvent(scope.row.targetSns, scope.row.type)"
                    ><i class="mdi mdi-open-in-new"></i>実際の応募ページを確認する</a
                  ></el-dropdown-item
                >
                <el-dropdown-item command="applicant_page_sample_dialog">
                  <div @click="openWebInstantwinPreviewDialog(scope.row.preview)">応募ページプレビューを確認する</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- 分析-->
            <el-tooltip :enterable="false" placement="top" content="分析" v-if="isEnabledAnalytics(scope.row)">
              <el-button
                class="el-button--icon ml-x1"
                type="default"
                @click="openAnalyticsDialog(scope.row.id, scope.row.target_sns || scope.row.targetSns, scope.row.type)"
                ><i class="mdi mdi-finance"></i
              ></el-button>
            </el-tooltip>
            <!-- その他の操作（複製/キャンペーンメモ）-->
            <el-dropdown class="ml-x1" trigger="click" placement="bottom-end">
              <el-button class="el-button--icon" type="default"><i class="mdi mdi-dots-horizontal"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <!-- 複製-->
                <el-dropdown-item>
                  <div
                    class="action-menu-item"
                    :class="{ 'is-disabled': isDuplicateMenuDisabled(scope.row) }"
                    @click="openDuplicateDialog(scope.row)"
                  >
                    <i class="mdi mdi-content-duplicate"></i>複製
                  </div>
                </el-dropdown-item>
                <!-- キャンペーンメモ-->
                <el-dropdown-item>
                  <div
                    class="action-menu-item"
                    :class="{ 'is-disabled': memoFetching }"
                    @click="openMemoDialog(scope.row.id)"
                  >
                    <i class="mdi mdi-file-document-edit-outline"></i>キャンペーンメモ
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :total="options.total"
      :pagingNo="options.pagingNo"
      :limitCount="options.limitCount"
      :onChangePagingNo="onChangePagingNo"
      :onChangeLimitCount="onChangeLimitCount"
    ></pagination
    ><DialogCampaignCreate ref="DialogCampaignCreate" @campaignUpdated="$emit('campaignUpdated')" />
    <DialogInstagramCampaignEdit ref="DialogInstagramCampaignEdit" @campaignUpdated="$emit('campaignUpdated')" />
    <DialogTwitterCampaignEdit ref="DialogTwitterCampaignEdit" @campaignUpdated="$emit('campaignUpdated')" />
    <DialogTikTokCampaignEdit ref="DialogTikTokCampaignEdit" @campaignUpdated="$emit('campaignUpdated')" />
    <TwitterWebInstantwinPreview ref="TwitterWebInstantwinPreview" />
    <CampaignMemoDialog
      :visible="memoDialogVisible"
      :campaign-id="memoCampaignId"
      @close="closeMemoDialog"
      @saved="onMemoSaved"
    />
    <CampaignTweetPostDialog
      :visible="tweetPostDialogVisible"
      :campaign-id="tweetPostCampaignId"
      :campaign-title="tweetPostCampaignTitle"
      :status="tweetPostCampaignStatus"
      :has-tweet-post-url="tweetPostCampaignHasUrl"
      :screen-name="tweetPostCampaignScreenName"
      @close="closeTweetPostDialog"
      @saved="onTweetPostSaved"
    />
  </div>
</template>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.campaign-title {
  max-height: $spacing-unit * 4 + 2;
  overflow: hidden;
  line-height: 18px;
}

.sub-value {
  font-size: $font-small-size;
}

.period-cell {
  white-space: nowrap;
}

.badge.badge-danger {
  position: initial;
  display: inline-block;
}

.action-menu-item {
  .mdi {
    margin-right: $spacing-unit;
  }

  &.is-disabled {
    color: $disabled-color;
    cursor: not-allowed;
  }
}

.entry-action-cell {
  white-space: pre-line;
}

:deep(.el-table th .sortable) {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
}

:deep(.el-table th .caret-wrapper) {
  flex-shrink: 0;
}
</style>
<script lang="ts">
import moment from 'moment-timezone'
import { mapActions, mapState } from 'pinia'
import Vue, { VueConstructor } from 'vue'

import Icon from '@/client/components/_atoms/basic_icon'
// basic_icon の Icon（アカウント画像用）と別物の mdi アイコン用コンポーネント。名前衝突を避けて別名で登録する。
import MdiIcon from '@/client/components/_atoms/Icon.vue'
import Pagination from '@/client/components/_atoms/pagination'
import IconButtonWithBadge from '@/client/components/_molecules/icon_button_with_badge'
import { DialogTikTokCampaignEdit, TwitterWebInstantwinPreview } from '@/client/components/_organisms'
import DialogCampaignCreate from '@/client/components/_organisms/DialogCampaignCreate.vue'
import DialogInstagramCampaignEdit from '@/client/components/_organisms/DialogInstagramCampaignEdit.vue'
import DialogTwitterCampaignEdit from '@/client/components/_organisms/DialogTwitterCampaignEdit.vue'
import { CAMPAIGN_STATUS } from '@/client/constant'
import Util from '@/client/core/util'
import CampaignAddEditDialog from '@/client/features/campaigns/components/campaign_add_edit_dialog'
import CampaignStatus from '@/client/features/campaigns/components/campaign_status'
import CampaignTweetPostDialog from '@/client/features/campaigns/components/campaign_tweet_post_dialog/CampaignTweetPostDialog.vue'
import CampaignMemoDialog from '@/client/features/campaigns/components/CampaignMemoDialog.vue'
import InstagramCampaignAnalyticsDialog from '@/client/features/campaigns/components/instagram_campaign_analytics_dialog'
import TiktokCampaignAnalyticsDialog from '@/client/features/campaigns/components/tiktok_campaign_analytics_dialog'
import TwitterCampaignAnalyticsDialog from '@/client/features/campaigns/components/twitter_campaign_analytics_dialog'
import { useCampaignMemoStore } from '@/client/features/campaigns/hooks/useCampaignMemoStore'
import { shouldShowUrlSettingIcon } from '@/client/features/campaigns/utils/campaignUrlSettingTarget'
import InstagramInstantwinCampaignAnalyticsDialog from '@/client/features/instagram_instantwin_campaign_analytics/components/InstagramInstantwinCampaignAnalyticsDialog.vue'
import { formatDatetime, formatNumber } from '@/client/filters/filters'
import { TrackingService } from '@/client/services'
import { useCampaignStore } from '@/client/store/useCampaignStore'
import { useSystemStore } from '@/client/store/useSystemStore'
import { getEntryActionListLabel } from '@/client/utils/campaign_entry_action_label'
import { TCampaign } from '@/typings/api/campaigns.type'

type WebInstantwinPreview = {
  beginUrl: string
  endUrl: string
  currentUrl: string
  authErrorUrl: string
}

export default (
  Vue as VueConstructor<
    Vue & {
      $refs: {
        campaignAddEditDialog: HTMLElement & { open: (mode: string, id: number, type: string, isCopy: boolean) => void }
        instagramCampaignAnalyticsDialog: HTMLElement & { open: (id: number) => void }
        instagramInstantwinCampaignAnalyticsDialog: HTMLElement & { open: (id: number) => void }
        tiktokCampaignAnalyticsDialog: HTMLElement & { open: (id: number) => void }
        twitterCampaignAnalyticsDialog: HTMLElement & { open: (id: number) => void }
        DialogCampaignCreate: HTMLElement & { open: (id?: number) => void }
        DialogInstagramCampaignEdit: HTMLElement & { open: (id: number) => void }
        DialogTwitterCampaignEdit: HTMLElement & { open: (id: number) => void }
        DialogTikTokCampaignEdit: HTMLElement & { open: (id: number) => void }
        TwitterWebInstantwinPreview: HTMLElement & {
          open: (preview: { beginUrl: string; endUrl: string; currentUrl: string; authErrorUrl: string }) => void
        }
      }
    }
  >
).extend({
  props: {
    campaigns: Array,
    options: Object,
    onChangePagingNo: Function,
    onChangeLimitCount: Function,
    onChangeSortBy: Function
  },
  components: {
    CampaignStatus,
    Pagination,
    Icon,
    MdiIcon,
    IconButtonWithBadge,
    CampaignAddEditDialog,
    CampaignMemoDialog,
    CampaignTweetPostDialog,
    TwitterCampaignAnalyticsDialog,
    InstagramCampaignAnalyticsDialog,
    InstagramInstantwinCampaignAnalyticsDialog,
    TiktokCampaignAnalyticsDialog,
    DialogCampaignCreate,
    DialogInstagramCampaignEdit,
    DialogTwitterCampaignEdit,
    DialogTikTokCampaignEdit,
    TwitterWebInstantwinPreview
  },
  data() {
    return {
      memoDialogVisible: false,
      memoCampaignId: null as number | null,
      tweetPostDialogVisible: false,
      tweetPostCampaignId: null as number | null,
      tweetPostCampaignTitle: '',
      tweetPostCampaignStatus: undefined as number | undefined,
      tweetPostCampaignHasUrl: false,
      tweetPostCampaignScreenName: ''
    }
  },
  computed: {
    ...mapState(useSystemStore, {
      contractStatus: state => state.currentGroup?.contractStatus,
      allowCreateInstantwin: state => Boolean(state.currentGroup?.allowCreateInstantwin),
      isSystemAdmin: state => Boolean(state.user?.isSystemAdmin)
    }),
    ...mapState(useCampaignMemoStore, {
      memoFetching: state => state.fetching
    })
  },
  methods: {
    formatDatetime,
    formatNumber,
    getEntryActionListLabel,

    ...mapActions(useCampaignStore, ['setLastQueryParams']),

    ...mapActions(useCampaignMemoStore, { resetMemoStore: 'reset' }),

    openMemoDialog(id: number) {
      if (this.memoFetching) return
      TrackingService.sendEvent('click:キャンペーン一覧|キャンペーンメモ')
      this.memoCampaignId = id
      this.memoDialogVisible = true
    },

    closeMemoDialog() {
      this.memoDialogVisible = false
      this.memoCampaignId = null
      this.resetMemoStore()
    },

    onMemoSaved() {
      this.closeMemoDialog()
    },

    /**
     * URL 設定アイコンの表示対象判定（リポスト/引用系 3 種のみ）
     */
    shouldShowUrlSettingIcon,

    /**
     * URL 設定ダイアログを開く
     */
    openTweetPostDialog(campaign: TCampaign) {
      TrackingService.sendEvent('click:キャンペーン一覧|応募収集URL設定')
      this.tweetPostCampaignId = campaign.id
      this.tweetPostCampaignTitle = campaign.title
      this.tweetPostCampaignStatus = campaign.status
      this.tweetPostCampaignHasUrl = Boolean(campaign.hasTweetPostUrl)
      this.tweetPostCampaignScreenName = campaign.account?.screenName ?? ''
      this.tweetPostDialogVisible = true
    },

    /**
     * URL 設定ダイアログを閉じる
     */
    closeTweetPostDialog() {
      this.tweetPostDialogVisible = false
      this.tweetPostCampaignId = null
      this.tweetPostCampaignTitle = ''
      this.tweetPostCampaignStatus = undefined
      this.tweetPostCampaignHasUrl = false
      this.tweetPostCampaignScreenName = ''
    },

    /**
     * URL 設定保存成功時：一覧全体を再取得して URL 設定状態・ステータスを同期する
     */
    onTweetPostSaved() {
      this.$emit('campaignUpdated')
    },

    isTwitterInstantwinStopped(targetSns: 'twitter' | 'instagram' | 'tiktok', type: string) {
      const cutoff = moment.tz('2025-11-01 00:00:00', 'Asia/Tokyo')
      const isAfterTargetDate = moment().tz('Asia/Tokyo').isSameOrAfter(cutoff)

      return isAfterTargetDate && type === 'instantwin' && targetSns === 'twitter'
    },

    isDuplicateDisabled(targetSns: 'twitter' | 'instagram' | 'tiktok', type: string) {
      if (this.isTwitterInstantwinStopped(targetSns, type)) {
        return true
      }

      return !this.isSystemAdmin && !this.allowCreateInstantwin && type === 'instantwin' && targetSns === 'twitter'
    },

    /**
     * 3点リーダー内の複製メニューを無効にするか（解約済みグループ or 複製不可のキャンペーン種別）
     */
    isDuplicateMenuDisabled(campaign: { targetSns: 'twitter' | 'instagram' | 'tiktok'; type: string }) {
      return this.contractStatus === 3 || this.isDuplicateDisabled(campaign.targetSns, campaign.type)
    },

    /**
     * 3点リーダー内の複製メニューからキャンペーン複製ダイアログを開く（無効時は何もしない）
     */
    openDuplicateDialog(campaign: { id: number; targetSns: 'twitter' | 'instagram' | 'tiktok'; type: string }) {
      if (this.isDuplicateMenuDisabled(campaign)) return
      this.openEditDialog(campaign.targetSns, campaign.id, campaign.type, true)
    },

    /**
     * SNS種別とコピー有無からモード文字列を返すヘルパー
     */
    resolveMode(snsType: string, isCopy: boolean): string {
      switch (snsType) {
        case 'instagram':
          return isCopy ? 'copyInstagram' : 'editInstagram'
        case 'tiktok':
          return isCopy ? 'copyTikTok' : 'editTikTok'
        default:
          return isCopy ? 'copyTwitter' : 'editTwitter'
      }
    },
    /**
     * 編集/複製ダイアログを開く（条件分岐簡素化版）
     * @param snsType SNS種別 (twitter|instagram|tiktok)
     * @param id キャンペーンID
     * @param type キャンペーンタイプ (instantwin等)
     * @param isCopy 複製フラグ
     */
    openEditDialog(snsType: string, id: number, type: string, isCopy = false) {
      TrackingService.sendEvent(`click:キャンペーン一覧|${isCopy ? '複製' : '編集'}`)

      const isTwitter = snsType === 'twitter'
      const isInstagram = snsType === 'instagram'
      const isTikTok = snsType === 'tiktok'
      const isEdit = !isCopy

      // 11月1日以降、Xインスタントウィンは廃止（編集のみ可能）
      if (this.isTwitterInstantwinStopped(snsType as 'twitter', type)) {
        if (isEdit) {
          return this.$refs.DialogTwitterCampaignEdit.open(id)
        }

        return
      }

      // Twitterインスタントウィン以外のSNS複製（共通）
      if (isCopy) {
        this.$refs.DialogCampaignCreate.open(id)
        return
      }

      if (isCopy && type !== 'instantwin') {
        this.$refs.DialogCampaignCreate.open(id)
        return
      }

      if (isEdit && isTwitter) {
        this.$refs.DialogTwitterCampaignEdit.open(id)
        return
      }

      if (isEdit && isInstagram) {
        this.$refs.DialogInstagramCampaignEdit.open(id)
        return
      }

      if (isEdit && isTikTok) {
        this.$refs.DialogTikTokCampaignEdit.open(id)
        return
      }
    },
    /**
     * ヘッダーをクリックするとソートする
     * @param {*} column
     */
    headerClick(column: any) {
      switch (column.label) {
        case 'ステータス':
          TrackingService.sendEvent('sort:キャンペーン一覧|ステータス')
          break
        case 'タイトル':
          TrackingService.sendEvent('sort:キャンペーン一覧|タイトル')
          break
        case '期間':
          TrackingService.sendEvent('sort:キャンペーン一覧|期間')
          break
        default:
          break
      }

      if (!column.sortBy) {
        return
      }
      if (column.sortBy.indexOf('-') === 0) {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy(column.sortBy.substring(1))
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      } else {
        if (this.options.sortBy === column.sortBy) {
          this.onChangeSortBy('-' + column.sortBy)
        } else {
          this.onChangeSortBy(column.sortBy)
        }
      }
    },
    /**
     * ヘッダー描画
     * @param {*} createElement
     * @param {*} { column }
     */
    renderHeader(createElement: any, { column }: any) {
      return Util.renderHeader(
        createElement,
        column.label,
        Util.getSortClass(this.options.sortBy, column.sortBy),
        !!column.sortBy
      )
    },

    /**
     * 分析ボタンの表示非表示を判定する
     */
    isEnabledAnalytics(campaign: { status: number; targetSns: string; type: string }) {
      const enabledStatus = [
        CAMPAIGN_STATUS.DURING_COLLECTION,
        CAMPAIGN_STATUS.DURING_FINAL_COLLECTION,
        CAMPAIGN_STATUS.COLLECTION_COMPLETED
      ]

      if (!enabledStatus.includes(campaign.status)) {
        return false
      }

      return true
    },
    /**
     * Open analytics dialog
     * @param {number} id
     * @param {string} targetSns
     */
    openAnalyticsDialog(id: number, targetSns: string, type: string) {
      TrackingService.sendEvent('click:キャンペーン一覧|分析')

      const refKeyMap: Record<string, keyof typeof this.$refs> = {
        instagram: 'instagramCampaignAnalyticsDialog',
        tiktok: 'tiktokCampaignAnalyticsDialog',
        twitter: 'twitterCampaignAnalyticsDialog'
      }

      const refKey =
        targetSns === 'instagram' && type === 'instantwin'
          ? 'instagramInstantwinCampaignAnalyticsDialog'
          : refKeyMap[targetSns]

      const ref: any = this.$refs[refKey]
      if (ref && typeof ref.open === 'function') {
        ref.open(id)
      }
    },
    /**
     * SNSで確認イベントの導入
     */
    clickSnsConfirmEvent(targetSns: string, type: string) {
      if (targetSns === 'twitter' && type === 'old_web_instantwin') {
        return TrackingService.sendEvent('click:キャンペーン一覧|キャンペーン応募ページ')
      }

      // SNS種別 -> イベント名 のマッピング
      const eventMap: Record<string, string> = {
        instagram: 'click:キャンペーン一覧|Instagramで確認',
        tiktok: 'click:キャンペーン一覧|TikTokで確認',
        twitter: 'click:キャンペーン一覧|Xで確認'
      }

      const eventName = eventMap[targetSns]

      if (eventName) {
        TrackingService.sendEvent(eventName)
      }
    },
    /**
     * キャンペーンタイトルのイベントの導入
     */
    clickCampaignTitleEvent(targetSns: string, type: string, id: number) {
      TrackingService.sendEvent('click:キャンペーン一覧|キャンペーンタイトル')

      // キャンペーン詳細ページに遷移する前にクエリパラメータを保存
      this.setLastQueryParams(this.$route.query)
      const path = this.resolveCampaignDetailRoute(targetSns, type, id)
      if (path) {
        this.$router.push(path)
      }
    },

    /**
     * ルーティング判定を一元化
     */
    resolveCampaignDetailRoute(targetSns: string, type: string, id: number): string | undefined {
      // Twitter インスタントウィン（例外）
      if (targetSns === 'twitter' && type === 'instantwin') {
        return `/twitter_instantwins/${id}`
      }

      // Instagram インスタントウィン（例外）
      if (targetSns === 'instagram' && type === 'instantwin') {
        return `/instagram_instantwins/${id}/prizes`
      }

      // SNS通常キャンペーン・(XWebインスタントウィン)
      const baseMap: Record<string, (id: number) => string | undefined> = {
        twitter: (id: number) => `/twitter_campaigns/${id}/prizes`,
        instagram: (id: number) => `/instagram_campaigns/${id}/prizes`,
        tiktok: (id: number) => `/tiktok_campaigns/${id}/prizes`
      }

      const builder = baseMap[targetSns]

      return builder(id)
    },

    /**
     * Web応募ページのメニュークリック時処理
     */
    selectActionMenu(command: string) {
      if (command === 'applicant_page_url') {
        return TrackingService.sendEvent('click:キャンペーン一覧|実際の応募ページを確認する')
      }

      if (command === 'applicant_page_sample_dialog') {
        return TrackingService.sendEvent('click:キャンペーン一覧|応募ページプレビューダイアログを開く')
      }
    },

    /**
     * Web応募ページのプレビューを開く
     */
    openWebInstantwinPreviewDialog(preview: WebInstantwinPreview) {
      this.$refs.TwitterWebInstantwinPreview.open(preview)
    }
  }
})
</script>
